import ordersAPI from "@/app/apis/main/orders/orders-api.js"

export default {
	/**
	 * @return {object} list of Orders
	 * @params queryParams
	 * */
	async getOrders(queryParams) {
		return ordersAPI.getOrders(queryParams)
	},

	/**
	 * @return {object} order
	 * @params orderId
	 * */
	async getOrderById(orderId) {
		return ordersAPI.getOrderById(orderId)
	},

	/**
	 * @return No content
	 * @params orderId
	 * @params body - tracking number, tracking link
	 * */
	async putOrderTrackingNumber(orderId, body) {
		return ordersAPI.putOrderTrackingNumber(orderId, body)
	},

	/**
	 * @return orderId
	 * @param orderId
	 * */
	async putApproveCancelOrder(orderId, details) {
		return ordersAPI.putApproveCancelOrder(orderId, details)
	},

	/**
	 * @return orderId
	 * @param orderId
	 * @param response - Disapproval Reason
	 * */
	async putDisapproveCancelOrder(orderId, response) {
		return ordersAPI.putDisapproveCancelOrder(orderId, response)
	},

	/**
	 * @return orderId
	 * @param orderId
	 * @param response - Disapproval Reason
	 * */
	async putDisapproveCancelProductOrder(orderId, response) {
		return ordersAPI.putDisapproveCancelProductOrder(orderId, response)
	},

	/**
	 * @return No Content
	 * @param {Number} orderId
	 * @param {Object} body { status }
	 * */
	async putUpdateOrderStatus(orderId, body) {
		return ordersAPI.putUpdateOrderStatus(orderId, body)
	},

	/**
	 * @return {object} list of Dog Purchase Orders
	 * @params queryParams
	 * */
	async getDogPurchaseOrders(queryParams) {
		return ordersAPI.getDogPurchaseOrders(queryParams)
	},
	/**
	 * @params orderId
	 * */
	async putApproveRefund(orderId, details) {
		return ordersAPI.putApproveRefund(orderId, details)
	},

	/**
	 * @params orderId
	 * @params response - disapproval Reason
	 * */
	async putDisapproveRefund(orderId, response) {
		return ordersAPI.putDisapproveRefund(orderId, response)
	},

	/**
	 * @params orderId
	 * @params response - disapproval Reason
	 * */
	async getPendingDogPurchaseOrders(queryParams) {
		return ordersAPI.getPendingDogPurchaseOrders(queryParams)
	},
	/**
	 * @params orderId
	 * */
	async deletePendingDogPurchaseOrders(orderId) {
		return ordersAPI.deletePendingDogPurchaseOrders(orderId)
	},

	/**
	 * @return orderId
	 * @param orderId
	 * */
	async putApproveCancelOrderStoreCredit(orderId, details) {
		return ordersAPI.putApproveCancelOrderStoreCredit(orderId, details)
	},

	/**
	 * no params
	 * */
	async getOrderForDeliveryCount() {
		return ordersAPI.getOrderForDeliveryCount()
	},

	async getOrdersReport(queryParams) {
		return ordersAPI.getOrdersReport(queryParams)
	},

	/**
	 * @params orderId
	 * @return
	 * */
	async putUpdateOrderProductStatus(orderId, status) {
		return ordersAPI.putUpdateOrderProductStatus(orderId, status);
	}
}
